import { useLayoutEffect, useRef } from "react";

export function Dialog({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose?: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);

  useLayoutEffect(() => {
    dialog.current?.showModal();
  }, [dialog]);

  return (
    <dialog
      ref={dialog}
      className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-4 backdrop:bg-black/20 backdrop:backdrop-blur-sm bg-transparent"
      onClose={(e) => {
        e.stopPropagation();
        onClose?.();
      }}
    >
      {children}
    </dialog>
  );
}
